import dateFormatter from '@/services/formatter_services/date-formatter';
import temporalAmountFormatService from '@/services/temporal-amount-format-service.js';
import { formatBool } from '@/utils/shared';
import { numberToPercent } from '@/utils/shared';
import dateService from '@/services/date-service';

const OVERTIME_HEADERS = Object.freeze([
  {
    text: 'Common.date',
    value: 'date',
    presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
  },
  { text: 'Common.employee', value: 'employee' },
  {
    text: 'Dashboard.widgets.overtime.headers.overtimeAmount',
    value: 'overtimeAmount',
    presentWith: temporalAmountFormatService.formatMinutesToWorkingHours
  },
  {
    text: 'Dashboard.widgets.overtime.headers.overtimeAmountConfirmed',
    value: 'overtimeAmountConfirmed',
    presentWith: temporalAmountFormatService.formatMinutesToWorkingHours
  },
  {
    text: 'Dashboard.widgets.overtime.headers.isConfirmed',
    value: 'isConfirmed',
    presentWith: formatBool
  },
  {
    text: 'Dashboard.widgets.overtime.headers.productivityFactor',
    value: 'productivityFactor',
    presentWith: numberToPercent
  },
  { text: 'Common.employee', value: 'employee' },
  { text: 'Dashboard.widgets.overtime.headers.editedBy', value: 'lastEditedBy' },
  {
    text: 'Dashboard.widgets.overtime.headers.confirmedAt',
    value: 'confirmedAt',
    presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
  },
  { text: 'Dashboard.widgets.overtime.headers.projectManager', value: 'projectManager' },
  { text: 'Common.matchcode', value: 'projectMatchcode' }
]);
const TIMETRACKING_WIDGETS = Object.freeze({
  OVERTIME_WIDGETS: [
    {
      id: 'overtime',
      path: 'overtime',
      getData: response => response.data.data?.map(item => item.data),
      headers: OVERTIME_HEADERS,
      type: 'TABLE',
      moduleId: 'overtime',
      withRouterActionLink: true
    },
    {
      id: 'overtimeCurrentMonth',
      path: 'overtime',
      defaultFilter: {
        from: dateService.getFirstDayOfCurrentMonth(),
        until: dateService.getLastDayOfCurrentMonth()
      },
      getData: response => response.data.data?.map(item => item.data),
      headers: OVERTIME_HEADERS,
      type: 'TABLE',
      moduleId: 'overtime',
      withRouterActionLink: true
    },
    {
      id: 'overtimeViewAmount',
      path: 'overtime',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'overtime'
    }
  ]
});

export default TIMETRACKING_WIDGETS;
